import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=222f4048&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"
import style0 from "./TableView.vue?vue&type=style&index=0&id=222f4048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f4048",
  null
  
)

export default component.exports